import { ReceiptType, ReceiptTypeCodes } from '@checkout-v2/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { RECEIPT_TYPES } from '../checkout-state';

export const LOAD_RECEIPT_TYPE = '[Checkout] Load receipt type';
export const LOAD_RECEIPT_TYPE_FAIL = '[Checkout] Load receipt type fail';
export const LOAD_RECEIPT_TYPE_SUCCESS = '[Checkout] Load receipt type success';
export const LOAD_RECEIPT_TYPE_RESET = '[Checkout] Load receipt type reset';

export const SET_ACTIVE_RECEIPT_TYPE = '[Checkout] Set active receipt type';

export class LoadReceiptType extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_RECEIPT_TYPE;

  constructor() {
    super(RECEIPT_TYPES);
  }
}

export class LoadReceiptTypeFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_RECEIPT_TYPE_FAIL;

  constructor(public payload: any) {
    super(RECEIPT_TYPES, payload);
  }
}

export class LoadReceiptTypeSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_RECEIPT_TYPE_SUCCESS;

  constructor(public payload: ReceiptType[]) {
    super(RECEIPT_TYPES);
  }
}

export class ResetReceiptType extends StateUtils.LoaderResetAction {
  readonly type = LOAD_RECEIPT_TYPE_RESET;

  constructor() {
    super(RECEIPT_TYPES);
  }
}

export class SetActiveReceiptType implements Action {
  readonly type = SET_ACTIVE_RECEIPT_TYPE;

  constructor(public payload: ReceiptTypeCodes) {}
}

export type ReceiptTypeActions =
  | LoadReceiptType
  | LoadReceiptTypeSuccess
  | LoadReceiptTypeFail
  | ResetReceiptType
  | SetActiveReceiptType;
